module.exports = "<h3 id=\"glossary\">Glossary</h3>\n<p><a href=\"index.md\">Back to index</a></p>\n";